class StockLineModel extends App.Models.BaseModel {
    modelUrl = '';
}

App.Models.StockLine = StockLineModel;
